import { isSothebys } from './BusinessLogic';

const isDevEnv = process.env.NODE_ENV.startsWith('dev');

const imagePath = isDevEnv ? '' : '/ar';

const invoicesPath = `${imagePath}/invoices`;

const reportsPath = `${window.location.origin}${imagePath}/reports`;

const isProd = ['aza', 'www'].includes(window.location.hostname.split('.')[0]);
const localDomain = window.location.hostname
  .split('.')[0]
  .toLowerCase()
  .replace('aza', '');

// bulk bidding
const bbSubDomain = () => {
  const subdomain = window.location.hostname.split('.')[0];
  const isDev = subdomain.startsWith('dev');
  const isFB01 = subdomain.startsWith('fb01');

  if (isDev || isFB01) return 'fb01';

  const isStage = subdomain.startsWith('stage');

  if (isStage) return 'stage';

  if (isProd) return 'www';

  return 'stage';
};

// cold fusion
const cfPath = () => {
  const baseURL = `https://${window.location.hostname}`;
  return isProd
    ? baseURL.replace('aza', 'www')
    : `${baseURL.replace('aza', '').replace('dev', 'stage')}`;
};

// az-house-admin-sas
const ahPath = () => {
  const baseURL = `https://${window.location.hostname}`;
  return isProd ? baseURL.replace('www', 'aza') : baseURL.replace('dev', 'stageaza');
};

// aza or stageaza
const azaStageazaPath = () => {
  const serverName = window.location.hostname.indexOf('auctionzipauctions') > -1
    ? 'auctionzipauctions'
    : 'invaluableauctions';
  const baseURL = `https://path.${serverName}.com/app`;
  return baseURL.replace('path', isProd ? 'aza' : 'stageaza');
};

/**
 * Prod path: https://www.invaluableauctions.com/al/auctionData...
 * Dev/Stage path: https://stage.invaluableauctions.com/al/auctionData...
 * Ptnr path: https://ptnr.invaluableauctions.com/al/auctionData...
 */
const sellerConsolePath = (catalogGUID, catalogRef) => {
  let baseURL = `https://${window.location.hostname}`;
  baseURL = isProd
    ? baseURL.replace('aza', 'www')
    : baseURL.replace('aza', '').replace('dev', 'stage');

  return `${baseURL}/al/auctionData/launchConsole.cfm?consoleType=seller&catalogGUID=${catalogGUID}&catalogRef=${catalogRef}`;
};

/**
 * (dyouberg)
 * Return the test bidder console path - which is available only to Sothebys.
 * Despite this - there are differences based on the staging environment which
 * need to be taken into account.
 */
const testBidderPath = catalogRef => {
  if (isProd) {
    return `http://sothebys.live.invaluable.com/catalog/${catalogRef}/bidder?am=17`;
  }

  if (localDomain === 'ptnr') {
    return `http://sothebys.live.partner.invaluable.com/catalog/${catalogRef}/bidder?am=25`;
  }

  return `http://sothebys.live.stage.invaluable.com/catalog/${catalogRef}/bidder?am=4`;
};

const toteboardPath = houseID => {
  let pathUrl = '';
  if (isProd) {
    pathUrl = isSothebys(houseID)
      ? 'http://sothebys.live.invaluable.com/catalog/'
      : 'https://live.invaluable.com/catalog/';
  } else {
    if (isSothebys(houseID)) {
      pathUrl = `http://sothebys.live.${
        ['ptnr', 'partner'].includes(localDomain) ? 'partner' : 'stage'
      }.invaluable.com/catalog/`;
    }

    pathUrl = `https://${localDomain}.live.invaluable.com/catalog/`;
  }

  return pathUrl;
};

const myAuctionPath = '/my-auctions/current';
const hostPrefix = process.env.NODE_ENV === 'production' ? 'www' : 'stage';
const hostServer = `https://${hostPrefix}.invaluableauctions.com`;
const awsServer = isProd ? 'https://image.invaluable.com' : 'https://stageimg.invaluable.com';

export {
  ahPath,
  azaStageazaPath,
  cfPath,
  hostServer,
  awsServer,
  imagePath,
  invoicesPath,
  reportsPath,
  isProd,
  myAuctionPath,
  sellerConsolePath,
  testBidderPath,
  toteboardPath,
  bbSubDomain
};
